import { Profession } from '@/types/user';

export const EMPLOYED_TYPE_OPTIONS = [
  Profession.Employee,
  Profession.Director,
].map(value => ({
  value,
  text: 'employerForm.form.employedType.option.' + value,
}));
